import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { Popover, Transition } from "@headlessui/react";
import classNames from "classnames";
import { Fragment } from "react";
var FlyoutMenu = function FlyoutMenu(props) {
  var cta = props.cta,
    children = props.children,
    panelClassName = props.panelClassName,
    ctaClassName = props.ctaClassName;
  return /*#__PURE__*/React.createElement(Popover, {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Popover.Button, {
    className: classNames("inline-flex justify-start items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900", _defineProperty({}, ctaClassName, !!ctaClassName))
  }, cta), /*#__PURE__*/React.createElement(Transition, {
    as: Fragment,
    enter: "transition ease-out duration-200",
    enterFrom: "opacity-0 translate-y-1",
    enterTo: "opacity-100 translate-y-0",
    leave: "transition ease-in duration-150",
    leaveFrom: "opacity-100 translate-y-0",
    leaveTo: "opacity-0 translate-y-1"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    className: classNames("absolute left-0 z-10 mt-3 flex bg-gray-100 dark:bg-gray-900 w-full rounded-lg border border-gray-500", _defineProperty({}, panelClassName, !!panelClassName))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex p-4 shadow-lg w-fit"
  }, children))));
};
export default FlyoutMenu;